import styled, { css } from "styled-components";

export const ContainerRight = styled.div`
  overflow-x: hidden;
  top: 90px;
  width: 37%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  left: 180px;
  padding: 10px;
  padding-top: 35px;
  & h4 {
    font-size: 18px;
    line-height: 26px;
    color: #05171d;
    font-family: OpenSans-Regular;
    font-weight: bold;
  }
  & h3 {
    font-size: 46px;
    margin: 0 0 30px;
    font-weight: 500;
  }
  @media only screen and (max-width: 767px) {
    width: 75%;
  }
`;

export const ContainerLeft = styled.div`
  width: 91%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  padding: 10px;
  & h4 {
    font-family: StagSansWeb-Medium;
    font-size: 25px;
    font-weight: 700;
    line-height: 28px;
    color: #05171d;
    margin: 0px 0px 25px;
  }
  & li {
    font-family: OpenSans-Semibold;
    font-size: 16px;
    list-style: none;
    line-height: 24px;
    padding: 10px 0;
    color: #05171d;
  }
  @media only screen and (max-width: 767px) {
    width: 75%;
  }
`;

export const Advantages = styled.ul`
  padding: 0;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const AdvantageList = styled.li`
  ${({ theme, content, color }) => css`
    &:before {
      width: 21px;
      content: "•";
      color: ${color};
      height: 12px;
      margin-right: 6px;
      background-repeat: no-repeat;
      font-size: 16px;
    }
  `}
`;

export const IncomeTypesList = styled.li`
  ${({ theme, content, color }) => css`
    &:before {
      width: 21px;
      content: "✓";
      color: ${color};
      height: 12px;
      margin-right: 6px;
      background-repeat: no-repeat;
    }
  `}
`;

export const Footer = styled.div`
  position: relative;
  top: 170px;
  background: #9599a0;
  display: flex;
  justify-content: center;
  padding: 40px 80px;
`;

export const SupportedTypes = styled.div`
  padding-left: 20%;
`;

export const SupportedTypesContainer = styled.div`
  width: 91%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  padding: 10px;
  & h4 {
    font-family: StagSansWeb-Medium;
    font-size: 25px;
    font-weight: 700;
    line-height: 28px;
    color: #05171d;
    margin: 0px 0px 25px;
  }
  & li {
    font-family: OpenSans-Semibold;
    font-size: 18px;
    line-height: 24px;
    padding: 10px 0;
    list-style: none;
    color: #05171d;
    border-bottom: 1px solid #979797;
  }
  @media only screen and (max-width: 767px) {
    width: 75%;
  }
`;

export const FooterList = styled.div`
  text-align: center;
  border: 1px solid #686e76;
  border-radius: 2px;
  padding: 25px 60px 20px 60px;
  margin: 5px;
  & p {
    font-size: 14px !important;
    line-height: 20px !important;
    color: #fff;
    padding-top: 10px;
  }
`;
